import type { PostMediaType } from '@/types/scheduler/post/media/mediaType';

export function getTypeFormMime(mimeType: string): PostMediaType['type'] {
    if (!mimeType) {
        return null;
    }
    const parts = mimeType.split('/');
    if (parts[1] === 'gif') {
        return 'gif';
    }

    if (parts[0] === 'application') {
        return 'document';
    }
    return parts[0] as PostMediaType['type'];
}
